import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import RecipeCard from '../components/RecipeCard';
import { useNavigate } from 'react-router-dom';
import StyledButton from '../components/StyledButton';
import FetRepTable from '../components/FetRepTable';

const baseURL = process.env.REACT_APP_API_URL;


const HomePage = () => {
    const navigate = useNavigate();
    const [recipes, setRecipes] = useState([]);

    useEffect(() => {
        const fetchRecipes = async () => {
            try {
                const res = await fetch(`${baseURL}/recipes`);
                const data = await res.json();
                const featured = data.filter(recipe => recipe.isFeatured);
                setRecipes(featured);
            } catch (err) {
                console.error("Failed to fetch recipes:", err);
            }
        };

        fetchRecipes();
    }, []);

    const handleAdd = () => {
        navigate('/addrecipe');
    };

    return (
        <>
            <Header />
            <div style={{ padding: "20px" }}>
                <h2 style={{ fontWeight: "bold" }}>Featured Recipes</h2>
            </div>
            <div style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "20px",
                marginTop: "20px",
                justifyContent: "center"
            }}>
                {recipes.map(recipe => (
                <RecipeCard
                    key={recipe._id}
                    recipe={{ ...recipe, image: recipe.image }} 
                    isFeatured={recipe.isFeatured}/>
                ))}
            </div>
            <div style={{ padding: '40px 20px', textAlign: 'center' }}>
                <h2 style={{ color: '#5E503F', fontWeight: 'bold', marginBottom: '16px' }}>
                    Have your own signature plate?
                </h2>
                <StyledButton onClick={handleAdd}>Add Recipe</StyledButton>
            </div>
        </>
    );
};

export default HomePage;